export default `
# Timberland ({domain}) robots.txt
User-agent: *

Disallow: */cart$
Disallow: */checkout*
Disallow: */order/success
Disallow: */search*
Disallow: */product/review
Disallow: /*/c/*?*
Disallow: /*/tag/*?*
Disallow: /*/explore/*?*
Disallow: /*/collections/*?*
Disallow: /*?CountryPref*
Disallow: /*/size-chart$
Disallow: /*/size-chart?

# AdsBot-Google
User-agent: AdsBot-Google
Disallow: */cart$
Disallow: */checkout/
Disallow: */order/success

# Googlebot
User-agent: Googlebot
Disallow:

#Googlebot-image
User-agent: Googlebot-image
Disallow:

# Amazon's user agent
User-agent: AmazonProductDiscoverybot
Disallow: /

#sitemap
Sitemap: {sitemapUrl}

# ThousandEyes Crawler
User-agent: Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.5993.70 Safari/537.36
Disallow: /
`
